export const fetchBooks = ({ access_token }) =>
  window.interceptFetch(`${process.env.REACT_APP_SERVER_URL}/books`, {
    method: 'GET',
    headers: {
      Authorization: access_token,
    },
  })
